/**
 * @generated SignedSource<<1f7e32c11886d37207bd30a2fd50cba1>>
 * @relayHash 45e74e6449de883ca47bf4939fcaafcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c254a78265ac21fbc0452cb2b4d6c3b2443e6119f21db286ea43384fd66bd5f7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type GoalPanelQuery$variables = {
  appSettingsContainerId?: string | null;
  ari: string;
  capabilitiesContainerId: string;
  includeDraftUpdate: boolean;
  includeWorkspaceTimezone?: boolean | null;
  queryContext?: string | null;
};
export type GoalPanelQuery$data = {
  readonly goals_appSettings?: {
    readonly appTimezone: string | null;
  } | null;
  readonly goals_byId: Result<{
    readonly id: string;
    readonly key: string;
    readonly latestDraftUpdate?: {
      readonly " $fragmentSpreads": FragmentRefs<"GoalDraftUpdateAdapter_draft">;
    } | null;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  } | null, unknown>;
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "appSettingsContainerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeWorkspaceTimezone"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v6 = {
  "condition": "includeWorkspaceTimezone",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "containerId",
          "variableName": "appSettingsContainerId"
        }
      ],
      "concreteType": "TownsquareGoalsAppSettings",
      "kind": "LinkedField",
      "name": "goals_appSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appTimezone"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "url"
},
v13 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v17 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v18 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v19 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v20 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v21 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = [
  (v11/*: any*/),
  (v7/*: any*/)
],
v24 = [
  (v7/*: any*/)
],
v25 = {
  "kind": "InlineFragment",
  "selections": (v24/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v27 = {
  "concreteType": "TownsquareGoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "value"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v31 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v29/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v30/*: any*/)
  ]
},
v32 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "kind"
},
v34 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v29/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v30/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "score"
},
v36 = [
  (v28/*: any*/),
  (v35/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v38 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v39 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v40 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v39/*: any*/)
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v42 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v43 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v44 = {
  "kind": "ScalarField",
  "name": "end"
},
v45 = {
  "kind": "ScalarField",
  "name": "start"
},
v46 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v47 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v44/*: any*/)
  ]
},
v48 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v47/*: any*/)
  ]
},
v49 = [
  (v28/*: any*/),
  (v7/*: any*/)
],
v50 = {
  "kind": "ScalarField",
  "name": "variance"
},
v51 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v49/*: any*/)
    },
    (v50/*: any*/)
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "type"
},
v53 = {
  "kind": "ScalarField",
  "name": "subType"
},
v54 = {
  "kind": "ScalarField",
  "name": "archived"
},
v55 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v56 = {
  "kind": "ScalarField",
  "name": "source"
},
v57 = {
  "kind": "ScalarField",
  "name": "time"
},
v58 = [
  (v57/*: any*/),
  (v7/*: any*/),
  (v28/*: any*/)
],
v59 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v60 = [
  (v59/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_DESC"
    ]
  }
],
v61 = [
  (v15/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/)
],
v62 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v36/*: any*/)
},
v63 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v64 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v65 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v66 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v64/*: any*/),
    (v65/*: any*/)
  ]
},
v67 = {
  "args": (v60/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v28/*: any*/),
            (v57/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v61/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v43/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v24/*: any*/)
                        },
                        (v62/*: any*/),
                        (v7/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v43/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v26/*: any*/),
            (v15/*: any*/)
          ]
        },
        (v63/*: any*/)
      ]
    },
    (v66/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
},
v68 = {
  "args": (v60/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v69 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v49/*: any*/)
},
v70 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v71 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v72 = [
  (v57/*: any*/),
  (v7/*: any*/)
],
v73 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v44/*: any*/)
  ]
},
v74 = {
  "args": (v60/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v72/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                (v73/*: any*/)
              ]
            },
            (v28/*: any*/)
          ]
        },
        (v50/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_DESC\"])"
},
v75 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v76 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    (v52/*: any*/)
  ]
},
v77 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v72/*: any*/)
},
v78 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v8/*: any*/),
                (v52/*: any*/),
                (v53/*: any*/),
                (v54/*: any*/),
                (v55/*: any*/),
                (v56/*: any*/),
                (v77/*: any*/)
              ]
            },
            (v69/*: any*/),
            (v70/*: any*/),
            (v71/*: any*/)
          ]
        }
      ]
    }
  ]
},
v79 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v36/*: any*/)
},
v80 = [
  (v47/*: any*/)
],
v81 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v80/*: any*/)
},
v82 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v83 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v84 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v85 = {
  "kind": "ScalarField",
  "name": "summary"
},
v86 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v87 = {
  "args": (v82/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v83/*: any*/),
            (v84/*: any*/),
            (v85/*: any*/),
            (v86/*: any*/),
            (v43/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v88 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v89 = [
  (v88/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v90 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v91 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v29/*: any*/)
},
v92 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v80/*: any*/)
},
v93 = [
  (v15/*: any*/),
  (v7/*: any*/)
],
v94 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v93/*: any*/)
  }
],
v95 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v93/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": (v94/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v96 = {
  "args": (v89/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v97 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v98 = [
  (v52/*: any*/),
  (v75/*: any*/)
],
v99 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v61/*: any*/)
},
v100 = {
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ]
},
v101 = {
  "kind": "ScalarField",
  "name": "description"
},
v102 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v101/*: any*/)
],
v103 = [
  (v59/*: any*/)
],
v104 = [
  {
    "concreteType": "TownsquareConnectedUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "sourceGoal",
        "plural": false,
        "selections": (v24/*: any*/)
      }
    ]
  }
],
v105 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v106 = [
  (v15/*: any*/),
  (v9/*: any*/),
  (v8/*: any*/),
  (v39/*: any*/),
  (v7/*: any*/)
],
v107 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v106/*: any*/)
},
v108 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v106/*: any*/)
},
v109 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v110 = [
  (v28/*: any*/),
  (v57/*: any*/),
  (v7/*: any*/)
],
v111 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v75/*: any*/)
  ]
},
v112 = [
  (v15/*: any*/),
  (v39/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/)
],
v113 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v47/*: any*/)
],
v114 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v8/*: any*/),
                (v7/*: any*/),
                (v39/*: any*/),
                (v9/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v86/*: any*/),
            (v43/*: any*/)
          ]
        }
      ]
    },
    (v26/*: any*/)
  ]
},
v115 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v85/*: any*/),
      (v101/*: any*/),
      (v107/*: any*/),
      (v108/*: any*/),
      (v43/*: any*/),
      (v109/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v116 = [
  (v88/*: any*/),
  (v13/*: any*/)
],
v117 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v94/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      (v6/*: any*/),
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "CatchField",
        "field": {
          "args": (v10/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            {
              "args": (v14/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            },
            {
              "condition": "includeDraftUpdate",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalDraftUpdate",
                  "kind": "LinkedField",
                  "name": "latestDraftUpdate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "GoalDraftUpdateAdapter_draft"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          },
          {
            "kind": "Variable",
            "name": "includeDraftUpdate",
            "variableName": "includeDraftUpdate"
          },
          (v13/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v17/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v20/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v21/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v8/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          (v27/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v7/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v7/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v35/*: any*/),
              {
                "concreteType": "TownsquareCompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v36/*: any*/)
              }
            ]
          },
          (v37/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v38/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  (v44/*: any*/),
                  (v45/*: any*/)
                ]
              },
              (v46/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v28/*: any*/),
                                  (v15/*: any*/),
                                  (v51/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          (v56/*: any*/),
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": (v58/*: any*/)
                          },
                          (v26/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/)
                        ]
                      },
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v15/*: any*/),
                      (v74/*: any*/)
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          (v76/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v76/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v7/*: any*/),
                          (v32/*: any*/)
                        ]
                      },
                      (v38/*: any*/),
                      (v78/*: any*/),
                      (v12/*: any*/),
                      (v79/*: any*/),
                      (v8/*: any*/),
                      (v41/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v7/*: any*/),
                          (v39/*: any*/)
                        ]
                      },
                      (v81/*: any*/),
                      (v87/*: any*/),
                      (v37/*: any*/),
                      {
                        "args": (v89/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v38/*: any*/),
                                  (v8/*: any*/),
                                  (v12/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  (v40/*: any*/),
                                  (v15/*: any*/),
                                  (v95/*: any*/)
                                ]
                              },
                              (v63/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v66/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v96/*: any*/)
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v97/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      },
                      (v54/*: any*/),
                      (v7/*: any*/),
                      (v38/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v34/*: any*/),
                          (v7/*: any*/),
                          (v32/*: any*/)
                        ]
                      },
                      (v8/*: any*/),
                      (v79/*: any*/),
                      (v12/*: any*/),
                      (v99/*: any*/),
                      (v81/*: any*/),
                      (v87/*: any*/),
                      (v37/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v70/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v48/*: any*/),
                                              (v28/*: any*/),
                                              (v51/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v7/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/),
                                      (v67/*: any*/),
                                      (v68/*: any*/)
                                    ]
                                  },
                                  (v71/*: any*/),
                                  (v69/*: any*/),
                                  (v74/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v17/*: any*/),
                          (v100/*: any*/)
                        ]
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/)
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v100/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v7/*: any*/),
              (v76/*: any*/),
              (v78/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v29/*: any*/)
              },
              (v8/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v41/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v101/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v65/*: any*/),
                  (v64/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v89/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": (v97/*: any*/),
                        "concreteType": "TownsquareTeamConnection",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareTeamEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v24/*: any*/)
                              }
                            ]
                          }
                        ],
                        "storageKey": "teams(first:50)"
                      },
                      (v15/*: any*/),
                      (v91/*: any*/),
                      (v40/*: any*/),
                      (v95/*: any*/),
                      {
                        "concreteType": "TownsquareProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "_id",
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v38/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      (v90/*: any*/),
                      (v92/*: any*/)
                    ]
                  },
                  (v15/*: any*/),
                  (v63/*: any*/)
                ]
              },
              (v66/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v96/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v102/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v102/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v102/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "args": (v103/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v63/*: any*/)
                                ]
                              },
                              (v66/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v103/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v101/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canSetMultipleValues"
                                  },
                                  {
                                    "args": (v103/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v28/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "args": (v103/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v63/*: any*/)
                                ]
                              },
                              (v66/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v103/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareConnectedUpdates",
            "kind": "LinkedField",
            "name": "connectedUpdates",
            "plural": false,
            "selections": [
              {
                "args": (v82/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "successMeasureUpdates",
                "plural": false,
                "selections": (v104/*: any*/),
                "storageKey": "successMeasureUpdates(first:1)"
              },
              {
                "args": (v82/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "subGoalUpdates",
                "plural": false,
                "selections": (v104/*: any*/),
                "storageKey": "subGoalUpdates(first:1)"
              },
              {
                "args": (v82/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "projectUpdates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareConnectedUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "sourceProject",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      }
                    ]
                  }
                ],
                "storageKey": "projectUpdates(first:1)"
              }
            ]
          },
          {
            "args": (v105/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v85/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v85/*: any*/),
                                  (v101/*: any*/),
                                  (v7/*: any*/),
                                  (v54/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v15/*: any*/),
                      (v43/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v83/*: any*/),
                      (v84/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      (v62/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v85/*: any*/),
                                  (v101/*: any*/),
                                  (v15/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTownsquareHighlight"
                                  },
                                  (v107/*: any*/),
                                  (v108/*: any*/),
                                  (v43/*: any*/),
                                  (v109/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      (v56/*: any*/),
                                      (v77/*: any*/),
                                      {
                                        "args": (v60/*: any*/),
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v110/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v110/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v58/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v54/*: any*/),
                                          (v8/*: any*/),
                                          (v52/*: any*/),
                                          (v53/*: any*/),
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v77/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v45/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v7/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v69/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v7/*: any*/),
                          (v37/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                              }
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v85/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v85/*: any*/),
                                                  (v101/*: any*/),
                                                  (v7/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          (v76/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v34/*: any*/),
                                  (v7/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v12/*: any*/),
                                      (v38/*: any*/),
                                      (v111/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v33/*: any*/),
                                          (v32/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      },
                                      (v79/*: any*/),
                                      (v99/*: any*/),
                                      (v81/*: any*/),
                                      (v87/*: any*/),
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v97/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v12/*: any*/),
                                      (v38/*: any*/),
                                      (v111/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v34/*: any*/),
                                          (v32/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      },
                                      (v79/*: any*/),
                                      (v99/*: any*/),
                                      (v81/*: any*/),
                                      (v87/*: any*/),
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v112/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v113/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      },
                      {
                        "args": (v97/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v111/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v39/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v86/*: any*/),
                      {
                        "args": (v103/*: any*/),
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v39/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "viewers(first:100)"
                      },
                      (v12/*: any*/),
                      (v114/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v36/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v113/*: any*/)
                      }
                    ]
                  },
                  (v63/*: any*/)
                ]
              },
              (v66/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": "updates(first:20)"
          },
          {
            "args": (v105/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "concreteType": "TownsquareGoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v72/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          },
          (v101/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          (v114/*: any*/),
          (v54/*: any*/),
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "isWatching"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v115/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v115/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v115/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v116/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v11/*: any*/),
                          (v85/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v63/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v66/*: any*/),
              (v26/*: any*/)
            ]
          },
          {
            "args": (v116/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectStatus",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryName"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryTargetDateEnd"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectOwner",
                            "plural": false,
                            "selections": (v112/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "externalOwner",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "firstName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastName"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v93/*: any*/)
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v117/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v117/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v117/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          },
          {
            "condition": "includeDraftUpdate",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalDraftUpdate",
                "kind": "LinkedField",
                "name": "latestDraftUpdate",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v79/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v73/*: any*/)
                        ]
                      },
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v69/*: any*/),
                                  (v70/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v85/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  (v35/*: any*/),
                  {
                    "concreteType": "TownsquareTargetDateInputDraft",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "date"
                      },
                      (v46/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareMetricUpdateInputDraft",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "targetId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      (v57/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateNoteInputDraft",
                    "kind": "LinkedField",
                    "name": "updateNotes",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      (v101/*: any*/),
                      (v22/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateHighlightInputDraft",
                    "kind": "LinkedField",
                    "name": "highlights",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      (v101/*: any*/),
                      (v52/*: any*/)
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "provenance_extension"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v61/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "c254a78265ac21fbc0452cb2b4d6c3b2443e6119f21db286ea43384fd66bd5f7",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "98ed061cdef4c2a478e913441e5fbdde";

export default node;
